/**
 * Wraps an apiClient with the SSE-correlation parameter convention used by the
 * Quantiix gateway. Every shell-side service should go through these helpers so
 * `client_id`, `correlation_id`, and `source` land on the URL the same way as
 * they do for the remote MFEs.
 *
 * @param {Object} apiClient - Result of createAPIClient(...).
 * @returns {Object} Methods: fetch, create, update, delete.
 */
export const createStandardAPIMethods = (apiClient) => ({
    fetch: (token, sseClientId, messageId, extraParams = {}, path = '') =>
        apiClient.get(token, {
            client_id: sseClientId,
            correlation_id: messageId,
            source: 'Shell-APP',
            ...extraParams
        }, path),

    create: (token, sseClientId, messageId, data, extraParams = {}, path = '') =>
        apiClient.create(token, data, {
            client_id: sseClientId,
            correlation_id: messageId,
            source: 'Shell-APP',
            ...extraParams
        }, path),

    update: (token, sseClientId, messageId, data, extraParams = {}, path = '') =>
        apiClient.update(token, data, {
            client_id: sseClientId,
            correlation_id: messageId,
            source: 'Shell-APP',
            ...extraParams
        }, path),

    delete: (token, sseClientId, messageId, extraParams = {}, path = '') =>
        apiClient.delete(token, {
            client_id: sseClientId,
            correlation_id: messageId,
            source: 'Shell-APP',
            ...extraParams
        }, path)
});